var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal custom-modal fade",
      attrs: { id: "detail_form", role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered modal-lg",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v("Post Schedule Detail")
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  ref: "dismisModal",
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close"
                  }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12 flexbox-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "of-card",
                      staticStyle: { width: "100%", "max-width": "343px" }
                    },
                    [
                      _c("div", { staticClass: "of-card-top" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "of-card-header" }, [
                        _c("div", { staticClass: "of-card-h-1" }, [
                          _c("div", { staticClass: "of-card-h-2" }, [
                            _c("div", { staticClass: "of-card-h-6" }, [
                              _c("div", [
                                _c("div", { staticClass: "of-card-h-7" }, [
                                  _vm.row.update_datetime
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatLocalDate(
                                              _vm.row.update_datetime
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  {
                                    ref: "account-" + _vm.row.id,
                                    staticClass: "tm"
                                  },
                                  [_c("Skeleton", { attrs: { count: 1 } })],
                                  1
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-end" }, [
                              _c(
                                "div",
                                { staticClass: "dropdown dropdown-action" },
                                [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right"
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: {
                                            to: "wizard?id=" + _vm.row.id,
                                            disabled:
                                              _vm.row.is_publish == 0 ||
                                              (_vm.row.sending_options == 2 &&
                                                _vm.row.sending_schedule >
                                                  _vm.currentDateTimeUnix())
                                                ? false
                                                : true
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-pencil m-r-5"
                                          }),
                                          _vm._v(
                                            " Edit\n                          "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: {
                                            to:
                                              "wizard?id=" +
                                              _vm.row.id +
                                              "&copy=1"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-copy m-r-5"
                                          }),
                                          _vm._v(
                                            " Copy\n                          "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: {
                                            href: "javascript:void(0)",
                                            "data-toggle": "modal",
                                            "data-target": "#summary_form",
                                            disabled:
                                              _vm.row.is_publish == 0 ||
                                              (_vm.row.sending_options == 2 &&
                                                _vm.row.sending_schedule >
                                                  _vm.currentDateTimeUnix())
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.showSearchFormSummary(
                                                _vm.row.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "la la-eye m-r-5"
                                          }),
                                          _vm._v(
                                            " Statistik\n                          "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: {
                                            disabled: _vm.isLoading,
                                            href: "javascript:void(0)"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.actionUpdateStatus(
                                                "unpublish"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "la la-pause"
                                          }),
                                          _vm._v(
                                            " Unpublish\n                          "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: {
                                            disabled: _vm.isLoading,
                                            href: "javascript:void(0)"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.actionUpdateStatus(
                                                "publish"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "la la-check"
                                          }),
                                          _vm._v(
                                            " Publish\n                          "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: {
                                            disabled: _vm.isLoading,
                                            href: "javascript:void(0)"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.actionDelete($event)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "la la-trash"
                                          }),
                                          _vm._v(
                                            " Delete\n                          "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "of-card-body" }, [
                        _c("div", { staticClass: "of-card-body-a" }, [
                          _c("div", { staticClass: "of-card-body-cap" }, [
                            _c("div", { staticClass: "of-card-body-cap-1" }, [
                              _c(
                                "p",
                                {
                                  staticClass: "of-card-body-cap-2",
                                  attrs: { title: _vm.row.caption }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.row.caption) +
                                      "\n                      "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "of-card-body-img" },
                            [
                              _vm.assetsUrl.length > 0
                                ? [
                                    _vm.assetsUrl[0].includes(".jpg") ||
                                    _vm.assetsUrl[0].includes(".jpeg")
                                      ? _c("img", {
                                          staticClass: "of-card-body-img-p",
                                          staticStyle: { cursor: "zoom-in" },
                                          attrs: {
                                            title: "Lihat Gambar",
                                            src: _vm.assetsUrl[0],
                                            alt: _vm.row.caption
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.openImage(_vm.assetsUrl)[0]
                                            }
                                          }
                                        })
                                      : _vm.assetsUrl[0].includes(".mp4")
                                      ? _c(
                                          "video",
                                          {
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%",
                                              overflow: "hidden"
                                            },
                                            attrs: { controls: "" }
                                          },
                                          [
                                            _c("source", {
                                              attrs: {
                                                src: _vm.assetsUrl[0],
                                                type: "video/mp4"
                                              }
                                            })
                                          ]
                                        )
                                      : _c("img", {
                                          staticClass: "of-card-body-img-p",
                                          attrs: {
                                            src: require("@/assets/placeholder.jpg"),
                                            alt: ""
                                          }
                                        })
                                  ]
                                : [
                                    _c("img", {
                                      staticClass: "of-card-body-img-p",
                                      attrs: {
                                        src: require("@/assets/placeholder.jpg"),
                                        alt: ""
                                      }
                                    })
                                  ]
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "of-card-body-b" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "of-card-body-c" }, [
                          _c("table", { staticClass: "of-card-table" }, [
                            _c("tbody", [
                              _c("tr", [
                                _c("td", { staticClass: "of-card-td-l" }, [
                                  _vm._v("Brand")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "of-card-td-r" }, [
                                  _c(
                                    "div",
                                    {
                                      ref: "brand-" + _vm.row.id,
                                      staticStyle: { width: "150px" }
                                    },
                                    [_c("Skeleton", { attrs: { count: 1 } })],
                                    1
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tbody", [
                              _c("tr", [
                                _c("td", { staticClass: "of-card-td-l" }, [
                                  _vm._v("Media Type")
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "of-card-td-r" }, [
                                  _c(
                                    "span",
                                    { staticClass: "badge badge-primary" },
                                    [_vm._v(_vm._s(_vm.row.media_type))]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tbody", [
                              _c("tr", [
                                _c("td", { staticClass: "of-card-td-l" }, [
                                  _vm._v("Reccuring")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "of-card-td-r",
                                    staticStyle: { "line-height": "19.5px" }
                                  },
                                  [
                                    _vm.row.is_recurring == 1
                                      ? [
                                          _c("i", {
                                            staticClass: "fa fa-clock-o"
                                          }),
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.row.recurrence) +
                                              "\n                            "
                                          ),
                                          _c("span", [
                                            _c("br"),
                                            _vm._v(
                                              "\n                              time:\n                              " +
                                                _vm._s(
                                                  _vm.formatHourFromUnix(
                                                    _vm.convertUTCDatetimeToUnix(
                                                      _vm.row.recurrence_time
                                                    )
                                                  )
                                                ) +
                                                "\n                            "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.row.recurrence != "daily"
                                            ? _c("span", [
                                                _c("br"),
                                                _vm._v(
                                                  "\n                              every: " +
                                                    _vm._s(
                                                      _vm.row.recurrence_every
                                                    ) +
                                                    "\n                              " +
                                                    _vm._s(
                                                      _vm.row
                                                        .recurrence_annually_month
                                                    ) +
                                                    "\n                            "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(
                                            "end:\n                            "
                                          ),
                                          _vm.row.recurrence_end == "never"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.row.recurrence_end)
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatLocalDate(
                                                      _vm.row
                                                        .recurrence_end_date
                                                    )
                                                  )
                                                )
                                              ])
                                        ]
                                      : [_vm._v("-")]
                                  ],
                                  2
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tbody", [
                              _c("tr", { staticStyle: { border: "none" } }, [
                                _c("td", { staticClass: "of-card-td-l" }, [
                                  _vm._v("Status")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "of-card-td-r",
                                    staticStyle: { "line-height": "19.5px" }
                                  },
                                  [
                                    _vm.row.is_publish == 0
                                      ? [
                                          _c(
                                            "span",
                                            { class: "text text-warning" },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-pause"
                                              }),
                                              _vm._v(
                                                "\n                              DRAFT\n                            "
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.row.is_publish == 1
                                      ? [
                                          _vm.row.sending_options == 1
                                            ? _c(
                                                "span",
                                                { class: "text text-success" },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  }),
                                                  _vm._v(
                                                    "\n                              SENT\n                              "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _vm.row.cron_timestamp > 0
                                                    ? _c("small", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.timeAgo(
                                                              _vm.row
                                                                .cron_timestamp
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("small", [
                                                        _vm._v(
                                                          "\n                                " +
                                                            _vm._s(
                                                              _vm.timeAgo(
                                                                _vm.row
                                                                  .update_datetime
                                                              )
                                                            ) +
                                                            "\n                                "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "(send now)\n                              "
                                                        )
                                                      ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.row.sending_options == 2 &&
                                          _vm.row.sending_schedule <
                                            _vm.currentDateTimeUnix()
                                            ? _c(
                                                "span",
                                                { class: "text text-success" },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  }),
                                                  _vm._v(
                                                    "\n                              Sent\n                              "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _vm.row.cron_timestamp > 0
                                                    ? _c("small", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.timeAgo(
                                                              _vm.row
                                                                .cron_timestamp
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.row.sending_options == 2 &&
                                          _vm.row.sending_schedule >
                                            _vm.currentDateTimeUnix()
                                            ? _c(
                                                "span",
                                                { class: "text text-info" },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-clock-o"
                                                  }),
                                                  _vm._v(
                                                    "\n                              Scheduled\n                              "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatLocalDateWithDay(
                                                          _vm.row
                                                            .sending_schedule
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "action-icon dropdown-toggle",
        attrs: {
          href: "javascript:void(0)",
          "data-toggle": "dropdown",
          "aria-expanded": "false"
        }
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("more_vert")]),
        _vm._v(" "),
        _c("span", { staticClass: "sr-only" }, [_vm._v("Toggle Dropdown")])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47816fba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47816fba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/instagram/instagramScheduleOfficial/detail.vue
// module id = null
// module chunks = 